import React, { Fragment } from 'react'
import { 
    Tooltip,IconButton
    } from '@mui/material';

import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

const LockButton = ({...props}) => {

    const { handleToggleLock, isLocked, packageId, userId} = props;

    return (
        <Fragment>
            {isLocked && 
                <Tooltip title="Unlock" onClick={e => handleToggleLock(e, packageId, userId)}>
                    <IconButton aria-label="unlock" size="large">
                        <LockOpenIcon />
                    </IconButton>
                </Tooltip>   
            }
            {!isLocked &&
                <Tooltip title="Lock" onClick={e => handleToggleLock(e, packageId, userId)}>
                    <IconButton aria-label="lock" size="large">
                        <LockIcon />
                    </IconButton>
                </Tooltip>   
            }
        </Fragment>
    );
}

export default LockButton;